const PROJECT_FEE_PACKAGE_DEFAULT = {
  id: '',
  projectID: '',
  name: '',
  description: '',
  code: '',
  orderPriority: 0,
  isEnabled: true,
  scheduleStartAt: null,
  scheduleEndAt: null,
  formulas: [],
  businessUnitAccesses: [],
  createdAt: null,
  updatedAt: null,
};

const PROJECT_FEE_PACKAGE_ITEM_DEFAULT = {
  id: '',
  projectFeePackageID: '',
  name: '',
  description: '',
  code: '',
  orderPriority: 0,
  isEnabled: true,
  category: 'list_price',
  formulaValue: '',
  newValue: 0,
  valueChange: 0,
  createdAt: null,
  updatedAt: null,
};

const PROJECT_UNIT_PACKAGE_FEE_DEFAULT = {
  id: '',
  projectID: '',
  projectUnitID: '',
  projectFeePackageID: '',
  orderPriority: 0,
  totalPrice: 0,
  createdAt: null,
  updatedAt: null,
};

export {
  PROJECT_FEE_PACKAGE_DEFAULT,
  PROJECT_FEE_PACKAGE_ITEM_DEFAULT,
  PROJECT_UNIT_PACKAGE_FEE_DEFAULT,
};



// WEBPACK FOOTER //
// ./src/structs/additional_fee.js